export default __webpack_public_path__ + "static/media/circleMarker.b90a1f05.svg";